import { mainColor, UNIT } from '../../constants/theme';

export const styles = () => ({
  progress: {
    margin: UNIT * 5,
    textAlign: 'center',
    color: mainColor.secondaryColor
  },
  versionText: { textAlign: 'right', marginRight: UNIT * 0.25 },
  gutters: {
    paddingLeft: 30,
    paddingRight: 30
  }
});
